// Lib
import chroma from 'chroma-js';

// Note: this is pretty much a duplicate of getIsLightColor from coreColorUtil.ts
// but without the Milanote specific text colour constants.
// We need to include this in here because of the monorepo structure meaning
// that we can't easily share code between the web app and the design system.

/**
 * Determines if the colour is light or dark based on the contrast of black or white text on top of them.
 */
export const isLightBackgroundColor = (color: string): boolean => {
    try {
        // calculate expected contrast ratio of light text or dark text
        const contrastDarkText = chroma.contrast('#000000', color);
        const contrastLightText = chroma.contrast('#FFFFFF', color);

        // then use the highest contrast version
        return contrastDarkText > contrastLightText;
    } catch (e) {
        // If the colour isn't valid then we'll just assume it's light
        return true;
    }
};
